<template>
  <div class="children-page-container">
     <div class="content-header">
       <div class="header-icon">
         <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
           <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
           <circle cx="12" cy="7" r="4"/>
         </svg>
       </div>
       <h1 v-if="!isDancer">Táncosok</h1>
       <h1 v-else>Saját adataim</h1>
       <p v-if="!isDancer">Válassz egy táncost a részletek megtekintéséhez</p>
       <p v-else>Saját táncos profilod</p>
     </div>

    <!-- If only one child is present, show single child card -->
    <div v-if="children?.length === 1" class="single-child-section">
      <div class="child-card child-card--single">
        <div class="child-card__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <div class="child-card__content">
          <h3>{{ children[0].fullName }}</h3>
          <p>Kattints a részletek megtekintéséhez</p>
        </div>
        <div class="child-card__arrow">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </div>
         <router-link :to="isDancer ? '/dancer/' + this.userId : '/children/' + children[0].id" class="child-card__link"></router-link>
      </div>
    </div>

    <!-- If there are multiple children, display them in a grid -->
    <div v-if="children?.length > 1" class="children-grid">
      <div
        v-for="child in children"
        :key="child.id"
        class="child-card"
      >
        <div class="child-card__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <div class="child-card__content">
          <h3>{{ child.fullName }}</h3>
          <p>Kattints a részletek megtekintéséhez</p>
        </div>
        <div class="child-card__actions">
          <button class="card-action-btn assign-btn" @click.stop="openAssignGroupModal(child)" title="Csoport hozzárendelése">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </button>
        </div>
        <div class="child-card__arrow">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </div>
        <router-link :to="'/children/' + child.id" class="child-card__link"></router-link>
      </div>
    </div>

    <!-- Empty state if no children are found -->
    <div v-if="children?.length === 0" class="empty-state">
      <div class="empty-state__icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
      <h3>Nincs megjeleníthető táncos</h3>
      <p>Jelenleg nincsenek elérhető táncosok a listában.</p>
    </div>

    <div v-if="upcomingLessons.length || upcomingCompetitions.length" class="events-section">
      <div v-if="upcomingLessons.length" class="lessons-section">
        <h2>Közelgő táncórák</h2>
        <div class="lesson-list">
          <div v-for="lesson in upcomingLessons" :key="lesson.id" class="lesson-card">
            <div class="lesson-card__name">{{ lesson.name }}</div>
            <div class="lesson-card__details">
              <span class="lesson-card__date">{{ lesson.next_dates }}</span>
              <span class="lesson-card__schedule">{{ parseSchedule(lesson.schedule) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="upcomingCompetitions.length" class="competitions-section">
        <h2>Közelgő versenyek</h2>
        <div class="competition-list">
          <div v-for="comp in upcomingCompetitions" :key="comp.id" class="competition-card">
            <div class="comp-date">{{ comp.comp_date }}</div>
            <div class="comp-title">{{ comp.title }}</div>
            <div v-if="comp.location" class="comp-location">{{ comp.location }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Assign Group mdl -->
    <div v-if="showAssignGroupModal" class="mdl-overlay" @click="closeAssignGroupModal">
      <div class="mdl-content" @click.stop>
        <div class="mdl-header">
          <h3>Csoport hozzárendelés - {{ selectedChildForGroup ? selectedChildForGroup.fullName : '' }}</h3>
          <button class="close-btn" @click="closeAssignGroupModal">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="mdl-body">
          <div class="form-group">
            <label>Csoport kiválasztása:</label>
            <select v-model="selectedGroupToAssign" class="modern-select">
              <option value="">Válassz csoportot...</option>
              <option v-for="group in availableGroups" :key="group.id" :value="group.id">
                {{ group.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="checkbox-label">
              <input type="checkbox" v-model="isPrimaryForAssignment" class="modern-checkbox" />
              <span class="checkbox-custom"></span>
              Elsődleges csoport
            </label>
          </div>
          <div class="mdl-actions">
            <button class="modern-btn modern-btn--success" :disabled="!selectedGroupToAssign" @click="assignChildToGroup">Hozzárendelés</button>
            <button class="modern-btn" @click="closeAssignGroupModal">Mégse</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {
        children: [],
        upcomingCompetitions: [],
        upcomingLessons: [],
        showAssignGroupModal: false,
        selectedChildForGroup: null,
        availableGroups: [],
        selectedGroupToAssign: '',
        isPrimaryForAssignment: false,
        isAdmin: false,
        isTeacher: false,
        isDancer: false,
        userId: null
      };
    },
    created() {
      this.getIsAdmin();
      this.getIsTeacher();
      this.getIsDancer();
      this.getUserId();
      if (this.isDancer && this.userId) {
        this.$router.push(`/dancer/${this.userId}`);
        return;
      }
      this.fetchChildren();
      this.fetchCompetitions();
      if (!this.isAdmin && !this.isTeacher) {
        this.fetchUpcomingLessons();
      }
    },
    watch: {
    // Watch the children array for changes
    children(newChildren) {
      if (newChildren?.length === 1) {
        if (this.isDancer) {
          this.$router.push(`/dancer/${this.userId}`);
        } else {
          this.$router.push(`/children/${newChildren[0].id}`);
        }
      }
    }
  },
    methods: {
      fetchChildren() {
        this.children = this.$getChildId();
      },
      getIsAdmin() {
        this.isAdmin = this.$isAdmin();
      },
      getIsTeacher() {
        this.isTeacher = this.$isTeacher();
      },
      getIsDancer() {
        this.isDancer = this.$isDancer();
      },
      getUserId() {
        this.userId = this.$getUserId();
      },
      async openAssignGroupModal(child) {
        this.selectedChildForGroup = child;
        this.selectedGroupToAssign = '';
        this.isPrimaryForAssignment = !child.groups || child.groups.length === 0 || !child.groups.some(g => g.is_primary);
        if (this.availableGroups.length === 0) {
          try {
            const response = await fetch(this.$BACKEND_HOST + '/api/settings/groups/info');
            const data = await response.json();
            this.availableGroups = data.groups || [];
            
            if (this.isTeacher && !this.isAdmin && this.userId) {
              const teacherResponse = await fetch(this.$BACKEND_HOST + '/api/settings/teachers/groups?teacher_id=${this.userId}');
              if (teacherResponse.ok) {
                const teacherData = await teacherResponse.json();
                const assignedGroupIds = teacherData.map(g => g.id);
                this.availableGroups = this.availableGroups.filter(group => assignedGroupIds.includes(group.id));
              }
            }
          } catch (error) {
            console.error('Error fetching groups:', error);
          }
        }
        this.showAssignGroupModal = true;
      },
      closeAssignGroupModal() {
        this.showAssignGroupModal = false;
        this.selectedChildForGroup = null;
        this.selectedGroupToAssign = '';
        this.isPrimaryForAssignment = false;
      },
      async assignChildToGroup() {
        if (!this.selectedGroupToAssign || !this.selectedChildForGroup) return;
        try {
          const response = await fetch(this.$BACKEND_HOST + '/api/child/groups/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              child_id: this.selectedChildForGroup.id,
              group_id: parseInt(this.selectedGroupToAssign),
              is_primary: this.isPrimaryForAssignment
            })
          });
          if (response.ok) {
            this.closeAssignGroupModal();
          } else {
            console.error('Failed to assign group');
          }
        } catch (error) {
          console.error('Error assigning group:', error);
        }
      },
      async fetchCompetitions() {
        try {
          const r = await fetch(this.$BACKEND_HOST + '/api/competitions/home');
          const d = await r.json();
          this.upcomingCompetitions = d.events || [];
        } catch (e) { console.error(e); }
      },
      async fetchUpcomingLessons() {
        try {
          const r = await fetch(this.$BACKEND_HOST + '/api/user/upcoming-lessons');
          const d = await r.json();
          this.upcomingLessons = d.lessons || [];
          const groupMap = {};
          this.upcomingLessons.sort((a, b) => a.next_dates.localeCompare(b.next_dates));
          this.upcomingLessons.forEach(lesson => {
            if (!groupMap[lesson.id]) {
              groupMap[lesson.id] = lesson;
            }
          });
          this.upcomingLessons = Object.values(groupMap);
        } catch (e) { console.error(e); }
      },
      parseSchedule(schedule) {
        try {
          const daysOfWeek = ["", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"];
          let parsed = JSON.parse(schedule);
          if (!Array.isArray(parsed)) {
            parsed = [parsed];
          }
          return parsed
            .filter(s => s && s.day && s.time)
            .map(s => `${daysOfWeek[s.day]} ${s.time}`)
            .join(", ");
        } catch (e) {
          return "Érvénytelen idő adat";
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .children-page-container {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    background: var(--color-background);
    min-height: 100vh;
  }

  .content-header {
    text-align: center;
    margin-bottom: 3rem;
    padding: 2rem;
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-sm);
  }

  .header-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    background: var(--button-primary);
    border-radius: 16px;
    margin-bottom: 1rem;
    color: white;
  }

  .content-header h1 {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--color-text);
    margin: 0 0 0.5rem 0;
  }

  .content-header p {
    color: var(--color-text-muted);
    font-size: 1.1rem;
    margin: 0;
  }

  .single-child-section {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .children-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
  }

  .child-card {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--color-border);
    padding: 2rem;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .child-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  .child-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
    border-color: var(--primary-blue);
  }

  .child-card:hover::before {
    transform: scaleX(1);
  }

  .child-card--single {
    max-width: 400px;
    width: 100%;
  }

  .child-card__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: var(--button-primary);
    border-radius: 12px;
    color: white;
    margin-bottom: 1.5rem;
  }

  .child-card__content {
    margin-bottom: 1.5rem;
  }

  .child-card__actions {
    position: absolute;
    top: 1rem;
    right: 1rem;
    display: flex;
    gap: 0.5rem;
  }

  .card-action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid var(--color-border);
    border-radius: 8px;
    background: var(--card-bg);
    color: var(--color-text-muted);
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .card-action-btn:hover {
    border-color: var(--primary-blue);
    color: var(--primary-blue);
    background: var(--hover-bg);
  }

  .card-action-btn.assign-btn {
    border-color: var(--success);
    color: var(--success);
  }

  .card-action-btn.assign-btn:hover {
    background: var(--success);
    color: white;
  }

  .child-card__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: var(--color-background-soft);
    border-radius: 50%;
    color: var(--color-text-muted);
    margin-left: auto;
    transition: all 0.2s ease;
  }

  .child-card:hover .child-card__arrow {
    background: var(--primary-blue);
    color: white;
    transform: translateX(4px);
  }

  .child-card__link {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    text-align: center;
  }

  .empty-state__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    background: var(--color-background-soft);
    border-radius: 50%;
    color: var(--color-text-muted);
    margin-bottom: 2rem;
  }

  .empty-state h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--color-text);
    margin: 0 0 0.5rem 0;
  }

  .empty-state p {
    color: var(--color-text-muted);
    font-size: 1rem;
    margin: 0;
  }

  @media (max-width: 768px) {
    .children-page-container {
      padding: 1rem;
    }

    .content-header {
      padding: 1.5rem;
      margin-bottom: 2rem;
    }

    .header-icon {
      width: 56px;
      height: 56px;
    }

    .content-header h1 {
      font-size: 2rem;
    }

    .children-grid {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }

    .child-card {
      padding: 1.5rem;
    }

    .child-card__content h3 {
      font-size: 1.25rem;
    }
  }

  @media (max-width: 480px) {
    .children-page-container {
      padding: 0.75rem;
    }

    .content-header {
      padding: 1rem;
    }

    .header-icon {
      width: 56px;
      height: 56px;
    }

    .content-header h1 {
      font-size: 1.75rem;
    }

    .children-grid {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }

    .child-card {
      padding: 1.5rem;
    }

    .child-card__content h3 {
      font-size: 1.25rem;
    }

    .empty-state {
      padding: 2rem 1rem;
    }

    .empty-state__icon {
      width: 80px;
      height: 80px;
    }
  }

  .mdl-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .mdl-content {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-lg);
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
  }

  .mdl-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid var(--color-border);
  }

  .mdl-header h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--color-text);
  }

  .mdl-body {
    padding: 1.5rem;
  }

  .mdl-body .form-group {
    margin-bottom: 1.25rem;
  }

  .mdl-body label {
    display: block;
    font-weight: 600;
    color: var(--color-text);
    margin-bottom: 0.5rem;
  }

  .mdl-actions {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-end;
    margin-top: 1.5rem;
  }

  .events-section {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--color-border);
    overflow: hidden;
    margin-bottom: 2rem;
  }

  .lessons-section,
  .competitions-section {
    padding: 1.5rem;
    border-top: 1px solid var(--color-border);
  }

  .lessons-section:first-child,
  .competitions-section:first-child {
    border-top: none;
  }

  .lessons-section h2,
  .competitions-section h2 {
    font-size: 1.25rem;
    margin: 0 0 1rem 0;
    color: var(--color-text);
  }

  .lesson-list,
  .competition-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .lesson-card,
  .competition-card {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    background: var(--color-background-soft);
    border-radius: 10px;
    border: 1px solid var(--color-border);
  }

  .lesson-card__name {
    font-weight: 600;
    color: var(--color-text);
    flex: 1;
  }

  .lesson-card__details {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
  }

  .lesson-card__date {
    font-weight: 700;
    color: var(--primary-blue);
    white-space: nowrap;
    font-size: 0.9rem;
  }

  .lesson-card__schedule {
    color: var(--color-text-muted);
    font-size: 0.85rem;
  }

  .comp-date {
    font-weight: 700;
    color: var(--primary-blue);
    white-space: nowrap;
  }

  .comp-title {
    font-weight: 600;
    color: var(--color-text);
  }

  .comp-location {
    color: var(--color-text-muted);
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    .lesson-card,
    .competition-card {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .lesson-card__details {
      align-items: flex-start;
    }
  }
</style>
  